import React, { useEffect } from 'react';
import NavBar from '../components/Home/NavBar';
import { Link } from 'react-router-dom';
import form2 from '../assets/forms/form2.png';
import form1 from '../assets/forms/form1.png';
import { useDispatch, useSelector } from 'react-redux';
import { getAnexoUser, getConsentimiento,  getConsentimientoNuevo,  getDDJJUser, getDDJJUserNuevo } from '../actions';
import Swal from 'sweetalert2';



const MisFormularios = () => {
  const token = localStorage.getItem('token')

  const ddjj = useSelector(state => state.ddjj)
  const ddjjNuevo = useSelector(state => state.ddjjUserNuevo)
  const anexoDoc = useSelector(state => state.anexoUser)
  const consentimiento = useSelector(state => state.consentimientoNuevo)

  
  const dispatch = useDispatch()
  
  useEffect(()=>{ 
    dispatch(getDDJJUser(token))
    dispatch(getAnexoUser(token))
    dispatch(getConsentimientoNuevo(token))
    dispatch(getDDJJUserNuevo(token))
  }, [])

  



  return (
    <div className='bg-bgSteps h-screen'>
      <NavBar />
      <div className='w-screen flex flex-col sm:flex-row items-center justify-center p-12 sm:pt-28 gap-12 sm:gap-20'>
        <div className='border border-slate-100 w-80 h-96 rounded-xl shadow-xl p-4 bg-white'>
          <img src={form2} alt='img not found' className='' />
          <div className='flex flex-col items-center justify-center gap-3 p-4'>
    <h1 className='font-bold'>Declaración Jurada</h1>
    <p className='text-xs'>
      Solicitud de Inscripción al Registro Nacional de Pacientes en Tratamiento con Cannabis (REPROCANN)
    </p>
    <button
      className='w-full p-2 px-4 rounded-xl bg-background_home text-white'
      onClick={() => {
        if (ddjj[2]) {
          window.open('/userDDJJ', '_blank', 'noopener noreferrer');
        } else {
          Swal.fire({
            title: 'Sin Formulario',
            text: 'No se encontró el formulario correspondiente.',
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Aceptar'
          });
        }
      }}
    >
      Ver
    </button>
  </div>
        </div>
        <div className='border border-slate-100 flex flex-col w-80 h-96 rounded-xl shadow-xl p-4 bg-white'>
          <img src={form1} alt='img not found' className='' />
            <div className='flex flex-col items-center justify-center gap-6 p-4'>
    <h1 className='font-bold'>Consentimiento</h1>
    <p className='text-xs'>Consentimiento Informado Bilateral</p>
    <button
      className='w-full p-2 px-4 rounded-xl bg-background_home text-white'
      onClick={() => {
        if (ddjj.length>0 && anexoDoc && consentimiento) {
          window.open('/AnexoUser', '_blank', 'noopener noreferrer');
        } else {
          Swal.fire({
            title: 'Sin Formulario',
            text: 'No se encontró el formulario correspondiente.',
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Aceptar'
          });
        }
      }}
    >
      Ver
    </button>
  </div>
        </div>

        <div className='border border-slate-100 w-80 h-96 rounded-xl shadow-xl p-4 bg-white'>
          <img src={form2} alt='img not found' className='' />
          <div className='flex flex-col items-center justify-center gap-3 p-4'>
    <h1 className='font-bold'>Renovación Declaración Jurada</h1>
    <p className='text-xs'>
      Solicitud de Inscripción al Registro Nacional de Pacientes en Tratamiento con Cannabis (REPROCANN)
    </p>
    <button
      className='w-full p-2 px-4 rounded-xl bg-background_home text-white'
      onClick={() => {
        if (ddjjNuevo) {
          window.open('/RenovacionDDJJUser', '_blank', 'noopener noreferrer');
        } else {
          Swal.fire({
            title: 'Sin Formulario',
            text: 'No se encontró el formulario correspondiente.',
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Aceptar'
          });
        }
      }}
    >
      Ver
    </button>
  </div>
        </div>


        <div className='border border-slate-100 flex flex-col w-80 h-96 rounded-xl shadow-xl p-4 bg-white'>
          <img src={form1} alt='img not found' className='' />
            <div className='flex flex-col items-center justify-center gap-6 p-4'>
    <h1 className='font-bold'>Renovación Consentimiento</h1>
    <p className='text-xs'>Consentimiento Informado Bilateral</p>
    <button
      className='w-full p-2 px-4 rounded-xl bg-background_home text-white'
      onClick={() => {
        if (consentimiento) {
          window.open('/AnexoUserNuevo', '_blank', 'noopener noreferrer');
        } else {
          Swal.fire({
            title: 'Sin Formulario',
            text: 'No se encontró el formulario correspondiente.',
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Aceptar'
          });
        }
      }}
      >
      Ver
    </button>
  </div>
        </div>



    </div>
      </div>
  );
}

export default MisFormularios;
